import ImageSkeleton from "../../../components/skeletons/ImageSkeleton"
import { ArticlesSkeleton } from "../../../components/skeletons/ArticleSkeleton"

const Article = ({ pressData }) => {
  return (
    <>
      <ImageSkeleton src={pressData.photo} alt={pressData.name} custCls="mx-auto w-full object-cover" custH="h-[155px] sm:h-[170px] md:h-[175px] lg:h-[218px] 2xl:h-[320px]" isDarker />
      <div className="text-center px-4 md:px-6 lg:px-8 mb-2 mt-1">
        <p className="font-agcasmlt font-light text-sm sm:text-xl text-[#6d625a] text-center tracking-wider">{pressData.name}</p>
      </div>
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full">
        <div className="text-center mb-2">
          <span className="font-agcasmlt font-light text-base sm:text-lg text-[#6d625a] text-center tracking-wider">{pressData.press_date}</span>
        </div>
        <div className="flex justify-center min-h-[24px] sm:min-h-[28px]">
          {pressData.link != "-" &&
            <a href={pressData.link} target="_blank" className="font-agcasmlt font-light text-base sm:text-lg text-[#6d625a] text-center tracking-wider underline uppercase">read more</a>
          }
        </div>
      </div>
    </>
  )
}

const Articles = ({ presses, onReq = false }) => {
  return (
    <div className="">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 lg:gap-8 2xl:gap-10">
        {presses.map((p, i) => (
          <div key={i} className="relative pb-[75px]">
            <Article pressData={p} />
          </div>
        ))}
        {onReq && <ArticlesSkeleton />}
      </div>
    </div>
  )
}

export {
  Article,
  Articles
}